import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import SkeletonLoader from "@widget/loaders/SkeletonLoader";
/**
 * Skeleton loader for login form while custom messages are being loaded
 */
const LoginFormSkeleton = ({ config }) => {
    // Determine form type and settings from config
    const formType = (config === null || config === void 0 ? void 0 : config.loginForm.type) || 'island-vertical';
    const isIslandHorizontal = formType === 'island-horizontal';
    const isIslandVertical = formType === 'island-vertical';
    const isFullpage = formType === 'fullpage';
    // Get active island config
    const islandHorizontalCfg = config === null || config === void 0 ? void 0 : config.loginForm.islandHorizontal;
    const islandVerticalCfg = config === null || config === void 0 ? void 0 : config.loginForm.islandVertical;
    const renderFormSkeleton = () => (_jsxs("div", { className: "uxpcore_loginform__skeleton", children: [_jsx(SkeletonLoader, { width: "120px", height: "40px", additionalStyle: { marginBottom: '1.5rem' } }), _jsx(SkeletonLoader, { width: "70%", height: "2rem", additionalStyle: { marginBottom: '0.5rem' } }), _jsx(SkeletonLoader, { width: "90%", height: "1rem", additionalStyle: { marginBottom: '2rem' } }), _jsxs("div", { className: "uxpcore_loginform__skeleton-fields", children: [_jsx(SkeletonLoader, { width: "100%", height: "48px", additionalStyle: { marginBottom: '1rem' } }), _jsx(SkeletonLoader, { width: "100%", height: "48px", additionalStyle: { marginBottom: '1rem' } }), _jsx(SkeletonLoader, { width: "60%", height: "20px", additionalStyle: { marginBottom: '1.5rem' } })] }), _jsx(SkeletonLoader, { width: "100%", height: "48px" })] }));
    /**
     * Render island horizontal skeleton
     */
    if (isIslandHorizontal && islandHorizontalCfg) {
        return (_jsx("div", { className: classNames('uxpcore_loginform__island-wrapper', {
                [`uxpcore_loginform__island-wrapper--${islandHorizontalCfg.position}`]: true
            }), children: _jsx("div", { className: classNames('uxpcore_loginform__island', 'uxpcore_loginform__island--horizontal', {
                    'uxpcore_loginform__island--glass': islandHorizontalCfg.glassEffect
                }), children: renderFormSkeleton() }) }));
    }
    /**
     * Render island vertical skeleton
     */
    if (isIslandVertical && islandVerticalCfg) {
        return (_jsx("div", { className: classNames('uxpcore_loginform__island-wrapper', {
                [`uxpcore_loginform__island-wrapper--${islandVerticalCfg.position}`]: true
            }), children: _jsxs("div", { className: classNames('uxpcore_loginform__island', 'uxpcore_loginform__island--vertical', {
                    'uxpcore_loginform__island--glass': islandVerticalCfg.glassEffect
                }), children: [_jsx("div", { className: "uxpcore_loginform__island-left", children: renderFormSkeleton() }), _jsx("div", { className: "uxpcore_loginform__island-right" })] }) }));
    }
    /**
     * Render fullpage skeleton
     */
    if (isFullpage) {
        return (_jsxs("div", { className: "uxpcore_loginform__fullpage", children: [_jsx("div", { className: "uxpcore_loginform__fullpage-left", children: renderFormSkeleton() }), _jsx("div", { className: "uxpcore_loginform__fullpage-right" })] }));
    }
    // Default fallback
    return (_jsx("div", { className: "uxpcore_loginform__container", children: renderFormSkeleton() }));
};
export default LoginFormSkeleton;
